<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span> {{ $t('reseller_form_title') }} </span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-text-field
                            v-model="value.name"
                            :label="$t('name')"
                            :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                            v-model="value.commission"
                            :label="$t('commission')"
                            :rules="[rules.required]"
                            class="ltr"
                    ></v-text-field>
                    <v-text-field
                            class="ltr"
                            :value="value.minimum_amount_settlement ? $n(value.minimum_amount_settlement) : null"
                            suffix="ریال "
                            v-model="value.minimum_amount_settlement"
                            @input="value.minimum_amount_settlement = parseInt($event)"
                            :hint="priceToTomanPhrase(value.minimum_amount_settlement)"
                            :label="$t('minimum_amount_settlement')"
                            :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                            v-model="value.iban_full_name"
                            :label="$t('iban_full_name')"
                    ></v-text-field>
                    <v-text-field
                            class="ltr"
                            v-model="value.iban_number"
                            :label="$t('iban_number')"
                            suffix="IR"
                            hint="فقط اعداد شماره شبا را وارد نمایید"
                    ></v-text-field>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('submit')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import { required} from '@/scripts/validationRules';
    import Service from "../services/ResellersService";
    import { priceToTomanPhrase } from '@/scripts/PriceUtils';

    export default {
        props: {
            item : {
                required: true
            }
        },
        computed : {
        },
        data() {
            return {
                validForm: false,
                loading: 0,
                value : {...this.item},
                rules: {
                    required
                },

            }
        },
        created(){


        },
        methods: {
            priceToTomanPhrase,
            async submit() {
                if(!this.validForm) {
                    return this.$refs.form.validate();
                }

                try {
                    this.loading++;

                    let {
                        data
                    } = this.value.id ? await Service.update(this.value) : await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');
            }
        }
    }
</script>